// satisfies の中で参照している型にだけ consistent-type-imports が値の import を
// 要求する (エラーは "is used by decorator metadata"。tsconfig に
// emitDecoratorMetadata は無いのでルール側の誤判定)。@spwn/types/spwn/ticket は
// 値の export を持たない型だけのモジュールなので、値として import はできない。
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import type {
  TicketClass as SharedTicketClass,
  VenueTicketClass,
} from "@spwn/types/spwn/ticket";

// main/apps/admin/src/types/firestore.d.tsに定義されている
// firestore.d.tsのinterface EventTicket extends Model参照
export const TICKET_CLASS = {
  SPECIAL_BONUS_VENUE: 1,
  BONUS_VENUE: 2,
  VENUE: 3,
  LIVE_STREAM: 7,
  VOD_STREAM: 8,
} as const satisfies Record<string, SharedTicketClass>;

export type TicketClass = (typeof TICKET_CLASS)[keyof typeof TICKET_CLASS];

/**
 * 判定に使う値は legacy/packages/functions にも同じものがある。共有パッケージへ
 * 切り出せないのは、functions が @spwn/types をtsconfigのpathsだけで解決しており
 * ランタイム値を import できないため。
 * 代わりに共有型 VenueTicketClass をキーにすることで、列挙の過不足をコンパイル時に
 * 検出する。値の true に意味はなく、キーを列挙するための入れ物。
 */
const VENUE_TICKET_CLASSES: Record<VenueTicketClass, true> = {
  [TICKET_CLASS.SPECIAL_BONUS_VENUE]: true,
  [TICKET_CLASS.BONUS_VENUE]: true,
  [TICKET_CLASS.VENUE]: true,
};

export const isVenueTicketClass = (ticketClass: number): boolean => {
  return ticketClass in VENUE_TICKET_CLASSES;
};
